// 後端回傳的圖片欄位存的是相對路徑（/api/files/preview/<file_key>），
// 前台與 API 不同網域時（測試機、正式機）直接塞進 <img src> 會打到前台網域而 404，
// 因此依 public.apiBase 補上 API 的 origin。與後台 api/file.js 的 resolveFileUrl 對稱。
export function useFileUrl() {
  const config = useRuntimeConfig()

  // 圖片是瀏覽器去要的，即使在 SSR 期間組網址也必須用公開位址，不能用內網的 apiInternalBase
  const apiBase = config.public.apiBase || '/api'

  function resolveFileUrl(url) {
    if (!url) return ''
    // 檔案伺服器或第三方（Google／LINE 頭像）的絕對網址原樣使用
    if (/^https?:\/\//i.test(url)) return url
    if (/^https?:\/\//i.test(apiBase)) return new URL(apiBase).origin + url
    // apiBase 是相對路徑（開發走 devProxy）時同網域，原樣即可
    return url
  }

  return { resolveFileUrl }
}
